import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Redirect, Prompt } from 'react-router-dom'
import {
  fetchAndPopulateWizard,
  validateAndSetActiveStep,
  validateAllSteps,
  buildFullWizardFieldIdList,
  saveRecord,
  saveRecordWithSignatures,
  toggleHelpModal,
  saveDraft,
  fetchAndPopulateDraft,
  fetchAndPopulateAmendment,
  fetchAndPopulateReadOnlyWizard,
  fetchAndPopulateSignatures,
  resetWizardState,
  clearInfoMessages,
  setActiveStep,
  calculateInternalReview,
  reconstructWizardWithValues,
  setWizardSubmitted,
  setWizardSubmitting,
  createMetaCollection,
  createEncryptionCollection,
  createFieldOverridesCollection,
  setWizardSignatureErrors,
  setGenericSuccess,
  resolveWizardAttributesLogic,
} from './WizardActions'
import { clearErrorToast, setErrorToast, setCartQuantity, announce } from '../../actions'
import ReactMarkdown from 'components/Markdown/Markdown'
import { Body as ShellBody, Drawer } from 'components/Shell/Shell'
import Portal from 'components/Portal/Portal'
import store, { resolveFieldLogic } from '../../store'
import Field from './Field.js'
import * as WizardClasses from './WizardClasses'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import Checkout from 'components/Checkout/Checkout'
import { Spinner } from 'components/Loaders/Loaders'
import { history } from '../../store'
import { getFieldsByType, readFileAsText, parseUrlQuery } from 'utilities'
import deepCopy from 'deep-copy'
import './Wizard.scss'
import {
  BASE_URL,
  GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM,
  GET_REPORT_BY_JSON,
  GET_WEB_USER_ACTIVE_CART,
  SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY,
} from '../../requests'
import FileDownloader from 'components/FormManager/FileDownloader'
import x2js from 'x2js'
import {
  getUniqueJSONvalues,
  calculateReceiptItemsTotal,
  formatSignaturesForServer,
  calculateReceiptItemContainersTotal,
  getFirstFocusableScopedElement,
} from 'utilities'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import { Helmet } from 'react-helmet'
import _get from 'lodash/get'
import ImportIcon from '@tecuity/sos-icons/react/import'
import ExportIcon from '@tecuity/sos-icons/react/export'
import CheckIcon from '@tecuity/sos-icons/react/check'
import { LoginRedirectSwitch } from 'components/LoginRedirector/LoginRedirector'
import deepEqual from 'deep-equal'
import { PaymentError } from 'components/Checkout/PaymentCallback'
import SignatureSection from './ThirdPartySignatures'
import MessageCard from '../Shell/MessageCard'
import differenceInDays from 'date-fns/differenceInDays'
import { convertRepeaterRowsToColumnsObject } from '../../Utilities/Utilities'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'

// import shortid from 'shortid'
const xml2Json = new x2js()

export const SignaturesWizard = ({ match: { params } }) => (
  <ConnectedWizard signatures token={params.token} />
)

export const AmendmentEditor = ({ match: { params }}) => (
  <ConnectedWizard
    amendment
    mode="amendment"
    formDefinitionId={params.formDefinitionId}
    amendmentNum={params.amendmentNum}
  />
)

export const ReadOnlyWizard = ({ match: { params } }) => (
  <ConnectedWizard
    readOnly
    formDefinitionId={params.formDefinitionId}
    amendmentNum={params.amendmentNum}
  />
)

export const CorrectionEditor = ({ match: { params }}) => (
  <ConnectedWizard
    correction
    mode="correction"
    correctionMode
    formDefinitionId={params.formDefinitionId}
    amendmentNum={params.amendmentNum}
  />
)

export const DraftEditor = ({ match: { params }}) => (
  <ConnectedWizard draft draftId={params.draftId} />
)

export class ConnectedWizard extends Component {
  state = { firstFetchSent: false }
  componentWillMount = () => {
    const search = parseUrlQuery(_get(this.props, 'location.search', '?'))
    if (!search.prefilled) {
      this.props.resetWizardState()
    }
  }
  componentDidMount = () => {
    this.fetchWizardDefinition()
    this.setState({ firstFetchSent: true })
    window.ALLOW_BYPASS_WIZARD_PROMPT = false
  }
  fetchWizardDefinition = () => {
    if (this.props.signatures) {
      this.props.fetchAndPopulateSignatures(this.props.token)
      return
    }
    if (this.props.draft) {
      this.props.fetchAndPopulateDraft(this.props.draftId)
      return
    }
    if (this.props.readOnly) {
      this.props.fetchAndPopulateReadOnlyWizard({
        formDefinitionId: this.props.formDefinitionId,
        amendmentNum: this.props.amendmentNum,
      })
      return
    }
    if (this.props.correction || this.props.amendment) {
      this.props.fetchAndPopulateAmendment({
        formDefinitionId: this.props.formDefinitionId,
        amendmentNum: this.props.amendmentNum,
        mode: this.props.mode,
        category: this.props.category,
        correctionMode: this.props.correctionMode,
      })
      return
    }
    const search = parseUrlQuery(_get(this.props, 'location.search', '?'))
    if (!search.prefilled) {
      this.props.fetchAndPopulateWizard(this.props.match.params.formDefinitionId)
    }
  }
  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.hasLoadedDifferentWizard &&
      !this.props.draft &&
      !nextProps.wizardLoadFailed &&
      !this.props.isLoading &&
      this.state.firstFetchSent
    ) {
      this.props.resetWizardState()
      this.fetchWizardDefinition()
    }
  }
  toggleHelpModal = () => {
    this.props.toggleHelpModal(false)
  }
  render() {
    const {
      helpShown,
      help,
      isLoading,
      submitted,
      submitting,
      wizardLoadFailed,
      wizardLoadErrorMessage,
      wizardLoadErrorTitle,
      siteOffline,
      genericSuccess,
    } = this.props
    return (
      <ShellBody
        showDrawer={helpShown}
        className={genericSuccess ? 'receipt-wrapper flex-center-page generic-success-page' : ''}
      >
        {(submitted || submitting) && <div className="submit-shield" />}
        {isLoading ? (
          <div className="wizard-loader-wrapper loader-wrapper">
            <Spinner className="page-loader animated fadeIn fast-animation" themeColor="neutral" />
          </div>
        ) : wizardLoadFailed ? (
          <div className="payment-callback">
            <PaymentError errorTitle={process.env.WIZARD_ERROR_TITLE_MESSAGE || wizardLoadErrorTitle}>
              {wizardLoadErrorMessage ? (
                <ReactMarkdown source={wizardLoadErrorMessage} className="markdown" />
              ) : (
                'We encountered an error while loading this form. Try again later, and if the problem persists please contact customer support.'
              )}
            </PaymentError>
          </div>
        ) : genericSuccess ? (
          <MessageCard
            className="animated fadeInUp"
            title={
              <span className="flex-center-row">
                <div className="generic-success-icon">
                  <CheckIcon />
                </div>
                {genericSuccess.title}
              </span>
            }
            content={genericSuccess.message}
          />
        ) : (
          <Wizard />
        )}
        <Drawer
          title="Help"
          show={helpShown}
          showCloseButton={true}
          alwaysShowClosebutton
          onSidebarDismiss={this.toggleHelpModal}
          ariaCloseLabel="Close help"
        >
          {isLoading ? (
            <Spinner className="page-loader" />
          ) : (
            <ReactMarkdown className="markdown" source={help} escapeHtml />
          )}
        </Drawer>
        {siteOffline && <Redirect to="/" />}
      </ShellBody>
    )
  }
}
ConnectedWizard = connect(
  (state, props) => ({
    hasLoadedDifferentWizard: props.signatures
      ? false
      : !props.draft &&
        !props.correction &&
        !props.readOnly &&
        !props.amendment &&
        !props.signatures
      ? props.match.params.formDefinitionId !== state.wizard.wizard.formDefinitionId
      : state.wizard.wizard.formDefinitionId !== props.formDefinitionId,
    helpShown: state.wizard.helpShown,
    help: state.wizard.wizard.steps[state.wizard.wizard.stepOrder[state.wizard.activeStep]]
      ? state.wizard.wizard.steps[state.wizard.wizard.stepOrder[state.wizard.activeStep]].help
      : '',
    isLoading: state.wizard.loadingWizard,
    submitted: state.wizard.submitted,
    submitting: state.wizard.submitting,
    wizardLoadFailed: state.wizard.wizardLoadFailed,
    wizardLoadErrorMessage: state.wizard.wizardLoadErrorMessage,
    wizardLoadErrorTitle: state.wizard.wizardLoadErrorTitle,
    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
    genericSuccess: state.wizard.genericSuccess,
  }),
  {
    fetchAndPopulateWizard,
    toggleHelpModal,
    fetchAndPopulateDraft,
    fetchAndPopulateAmendment,
    fetchAndPopulateReadOnlyWizard,
    fetchAndPopulateSignatures,
    resetWizardState,
  }
)(ConnectedWizard)

class Wizard extends Component {
    constructor(props) {
    super(props)
    this.state = {
      isMobile: false
    }
  }
  componentDidMount = () => {
    this.handleIsMobile();
    const focusable = process.env.SHOW_SCROLL_DOWN_ARROW ? this.state.isMobile === true ? document.getElementById("wizard-body-scrollArrow-container-mobile") : document.getElementById("wizard-body-scrollArrow-container") : document.getElementById("wizard-body-scroll-container")
    if(focusable){
      focusable.focus()
    }
  }
  handleIsMobile = () => {
    let ret = document.body.clientWidth < 600
    this.setState({
        isMobile: ret,
      })
  }
  componentWillReceiveProps = (nextProps) => {
    const stepHasChanged = nextProps.activeStep !== this.props.activeStep
    if(stepHasChanged){
      this.wizardBody.scrollToTop()
    }
  }
  componentDidUpdate = (prevProps) => {
    const stepHasChanged = prevProps.activeStep !== this.props.activeStep
    if (stepHasChanged) {
      this.setFocusOnWizardBody()
    }
  }
  setFocusOnWizardBody = () => {
    const firstFocusableNonHelp = getFirstFocusableScopedElement(process.env.SHOW_SCROLL_DOWN_ARROW ? this.state.isMobile ? "#wizard-body-scrollArrow-container-mobile" : "#wizard-body-scrollArrow-container" :  '#wizard-body-scroll-container', ':not(.help-button):not(.toolbar-button):not(.tip)')
    if(firstFocusableNonHelp){
      const isUploadSubmit = Array.from(firstFocusableNonHelp.classList).includes("selectable") && Array.from(firstFocusableNonHelp.parentNode.parentNode.classList).includes("upload-submit")
      if (isUploadSubmit){
        const selectedTab = document.querySelector(`#${firstFocusableNonHelp.parentNode.parentNode.id} .selectable[aria-selected="true"]`)
        if (selectedTab) {
          selectedTab.focus()
        }
        else {
          firstFocusableNonHelp.focus()
        }
      }
      else {
        firstFocusableNonHelp.focus()
      }
    }
    else{
      const firstFocusable = getFirstFocusableScopedElement( process.env.SHOW_SCROLL_DOWN_ARROW ? this.state.isMobile ? "#wizard-body-scrollArrow-container-mobile" : "#wizard-body-scrollArrow-container" :  '#wizard-body-scroll-container')
      if (firstFocusable){
        firstFocusable.focus()
      }
    }
  }
  toggleHelpModal = () => {
    this.props.toggleHelpModal(!this.props.helpShown)
  }
  continueAdvance = () => {
    this.props.setActiveStep(this.props.targetStep)
  }
  render() {
    const {
      steps = [],
      validating,
      loadingWizard,
      activeStep,
      title = 'Loading',
      readOnly,
      rootClassName = '',
      wizard,
      previewing,
      noLoginRequired,
      authenticated,
      location,
      mode,
    } = this.props
    const isInSignatureMode = mode === 'signature'
    return (
      <div className={'wizard container animated fadeInDown fast-animation ' + rootClassName} id="main-wizard-container">
        {!noLoginRequired && !authenticated && !previewing && (
          <LoginRedirectSwitch location={location} />
        )}
        <Prompt
          when={!previewing && !readOnly && authenticated}
          message={(location) => {
            if (
              window.ALLOW_BYPASS_WIZARD_PROMPT ||
              ((location.pathname === '/auth' ||
                location.pathname === '/admin' ||
                location.pathname === '/') &&
                !authenticated) ||
              location.pathname === '/receipt'
            ) {
              window.ALLOW_BYPASS_WIZARD_PROMPT = false
              return true
            } else {
              return (
                process.env.WIZARD_ON_EARLY_EXIT_MESSAGE ||
                `Are you sure you want to leave this form? Any unsaved data will be lost.

To save your work and resume editing later click "Save Draft" below.`
              )
            }
          }}
        />
        <div className="">
          <div className="row">
            <div className="col">
              <h1 className="wizard-title ">{title}</h1>
            </div>
            <Helmet>
              <title>{`${previewing ? '👁 ' : ''}${title || ''} | ${process.env.STATE_NAME} ${
                process.env.STATE_ORG_TITLE
              }`}</title>
            </Helmet>
          </div>
          <div className="row">
            <div className="col">
              <div className="wrapper">
                <div className="row row-eq-height">
                  {!isInSignatureMode && (
                    <div className="col-sm-4 col-md-3 col-lg-3 sidebar-wrapper">
                      <Sidebar>
                        {!loadingWizard
                          ? steps.map((step, i) => (
                              <StepButton
                                stepIndex={i}
                                title={step.title}
                                active={i === activeStep}
                                activeStep={activeStep}
                                isValid={step.isValid}
                                totalSteps={steps.length}
                                key={i}
                              />
                            ))
                          : null}
                      </Sidebar>
                    </div>
                  )}
                  <div
                    className={`${!isInSignatureMode ? 'col-sm-8 col-md-9 col-lg-9' : 'col-12'}`}
                  >
                    <Body
                      validating={validating}
                      readOnly={readOnly}
                      ref={(r) => {
                        this.wizardBody = r
                      }}
                      isFullWidth={isInSignatureMode}
                      activeStep={activeStep}
                    >
                      {!loadingWizard ? (
                        <form
                          onSubmit={(e) => {
                            e.preventDefault()
                          }}
                        >
                          {steps[activeStep] ? (
                            steps[activeStep].help !== '' && !readOnly && !isInSignatureMode ? (
                              <div className="help-wrapper">
                                <button
                                  type="button"
                                  className={`help-button ${process.env.WIZARD_ALT_HELP_STYLE ? "alt-style" : ""}`}
                                  onClick={this.toggleHelpModal}
                                  aria-label="Toggle additional help"
                                >
                                  {process.env.WIZARD_ALT_HELP_STYLE ? `Help ` : ""}?
                                </button>
                              </div>
                            ) : null
                          ) : null}
                          {!isInSignatureMode ? (
                            steps[activeStep].sections.map((section, i) =>
                              section.type !== 'confirm' ? (
                                <Section
                                  {...section}
                                  allFields={wizard.fields}
                                  index={i}
                                  zIndex={steps[activeStep].sections.length - i + 1}
                                  key={section.sectionId}
                                />
                              ) : null
                            )
                          ) : (
                            <SignatureSection />
                          )}
                        </form>
                      ) : null}
                    </Body>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
Wizard = connect(
  (state) => {
    let steps = state.wizard.wizard.steps
    let sections = state.wizard.wizard.sections
    let fields = state.wizard.wizard.fields

    let orderedSteps = state.wizard.wizard.stepOrder.map((stepId) => ({
      ...steps[stepId],
      sections: steps[stepId].sectionOrder.map((sectionId) => ({
        ...sections[sectionId],
        fields: sections[sectionId].fieldOrder.map((fieldId) => fields[fieldId]),
      })),
    }))
    return {
      steps: orderedSteps,
      wizard: state.wizard.wizard,
      title: state.wizard.wizard.title,
      activeStep: state.wizard.activeStep,
      targetStep: state.wizard.targetStep,
      validating: state.wizard.validating,
      loadingWizard: state.wizard.loadingWizard,
      helpShown: state.wizard.helpShown,
      readOnly: state.wizard.readOnly,
      previewing: state.wizard.preview,
      noLoginRequired: state.wizard.wizard.noLoginRequired,
      authenticated: state.auth.loggedIn && ['WEB', 'ADMIN_WEB'].includes(state.auth.USER_GROUP),
      location: state.router.location,
      mode: state.wizard.mode,
    }
  },
  { toggleHelpModal, clearInfoMessages, setActiveStep }
)(Wizard)
export default Wizard

class StepButton extends Component {
  setActiveStep = () => {
    this.props.clearErrorToast();
    if (this.props.readOnly) {
      this.props.setActiveStep(this.props.stepIndex)
    } else {
      this.props.validateAndSetActiveStep(this.props.stepIndex)
    }
  }
  render() {
    const { active, isValid, title, readOnly, stepIndex, totalSteps } = this.props
    return (
      <button
        className={(active ? 'active ' : ' ') + (isValid === false ? 'step-invalid' : '')}
        onClick={this.setActiveStep}
        aria-invalid={!isValid}
      >
        <div className={isValid || readOnly ? 'step-check step-valid' : 'step-check'}>
          {isValid === false && <div className="invalid-icon" />}
        </div>
        {title}
        <span className="visually-hidden">{`Step ${stepIndex + 1} of ${totalSteps}`}{isValid === false ? "There are errors on this step" : ""}</span>
      </button>
    )
  }
}
StepButton = connect(
  (state) => ({
    readOnly: state.wizard.readOnly,
  }),
  { clearErrorToast, validateAndSetActiveStep, setActiveStep }
)(StepButton)

const Sidebar = ({ children }) => <div className="sidebar">{children}</div>

class Body extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reachedBottom: false,
      isMobile: false,
    }
  }
  componentDidUpdate() {
    if (process.env.SHOW_SCROLL_DOWN_ARROW) {
      const element =
        this.state.isMobile === true
          ? document.getElementById('wizard-body-scrollArrow-container-mobile')
          : document.getElementById('wizard-body-scrollArrow-container')
      let position = element.scrollHeight - (element.clientHeight + element.scrollTop)

      if (position < 10 && this.state.isScrollable) {
        this.setState({ ...this.state, isScrollable: false })
      } else if (!this.state.isScrollable && position >= 10) {
        this.setState({ ...this.state, isScrollable: true })
      }
    }
  }



  componentDidMount = () => {
    if (process.env.SHOW_SCROLL_DOWN_ARROW) {
      this.handleIsMobile()
    }
  }


   handleIsMobile = () => {
        if (process.env.SHOW_SCROLL_DOWN_ARROW) {

    let ret = document.body.clientWidth < 600
    this.setState({
      isMobile: ret,
    })
  }
}

  scrollToTop = () => {
    this.wrapper.scrollTop = 0
  }
  render() {
    const { children, validating, isFullWidth } = this.props

  const handleScroll = (e) => {
        if (process.env.SHOW_SCROLL_DOWN_ARROW) {
      const bottom = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) < 10
      this.setState({
        reachedBottom: bottom,
      })
    }
  }

    return (
      <div
        className={`body ${isFullWidth ? 'full-width' : ''}`}
        ref={(r) => {
          this.wrapper = r
        }}
        id={(process.env.SHOW_SCROLL_DOWN_ARROW === true) ? (this.state.isMobile === true) ? "wizard-body-scrollArrow-container-mobile" : "wizard-body-scrollArrow-container" : "wizard-body-scroll-container"}
        tabIndex="-1"
        onScroll={process.env.SHOW_SCROLL_DOWN_ARROW ?  handleScroll : null}
      >
        {process.env.SHOW_SCROLL_DOWN_ARROW && this.state.isScrollable ? (
          <Fragment>
            <div className="scroll-down-container-bottom-right">
              <div className="scroll-down-text">Scroll Down</div>
              <div className="scroll-down-icon">
                <CaretDownIcon />
              </div>
            </div>
          </Fragment>
        ) : null}
        <div className={'validation-indicator ' + (validating ? 'show' : '')}></div>
        {validating ? <div className="validation-shade"></div> : null}
        {children}
        <Toolbar validating={validating} />
      </div>
    )
  }
}

const Section = ({ title, description = '', fields, index, zIndex = '', allFields }) => {
  const mappedFields = fields.map((rawField, i) => {
    if (rawField) {
      const field = resolveFieldLogic(rawField)
      return (
        field.active &&
        resolveFieldConditions(field.conditions, allFields, field.conditionsOperator) && (
          <Field
            field={field}
            isFirst={index === 0 && i === 0}
            bypassConditionCheck
            bypassLogicResolution
            key={field.fieldId}
          />
        )
      )
    } else {
      console.warn(`Attempted to render a field at index ${i} of section "${title}", but got null.`)
      return null
    }
  })
  return (
    mappedFields.some((f) => f) && (
      <div className="section" style={{ zIndex }}>
        {title ? <h2>{title}</h2> : null}
        {description && <ReactMarkdown className="description" source={description} />}
        {mappedFields}
        <div className="bottom-divider"></div>
      </div>
    )
  )
}

const GENERIC_SERVER_ERROR = `Something went wrong while we were trying to \
save your filing. Try submitting your filing again, and if the problem persists \
please contact customer support.`
const SHOPPING_CART = process.env.SHOPPING_CART

class Toolbar extends Component {
  constructor() {
    super()
    this.state = {
      submitted: false,
      checkoutOpen: false,
      receiptItems: [],
      receiptItemContainers: [],
      wizardValid: null,
      reportBlob: null,
      rawBlob: null,
      dataExport: null,
      serverError: null,
      transactionRefNum: null,
      availablePaymentMethods: undefined,
      screenReaderMessage: "",
      globalErrorMessage: ""
    }
    this.modalRef = React.createRef()
  }
  componentDidMount = () => {
    window.stringifyFields = () => JSON.stringify(this.props.fields)
    window.stringifyWizard = () => {
      console.log(JSON.stringify(this.getReportPreview()))
    }
    window.logWizard = () => this.buildFieldJSON()
    window.logCurrentStep = () => {
      return Object.values(this.props.wizard.wizard.sections)
        .filter((s) => s.stepId === this.props.wizard.wizard.stepOrder[this.props.activeStep])
        .flatMap((s) => Object.values(this.props.fields).filter((f) => f.parent.id === s.sectionId))
        .flatMap((f) =>
          f.hasOptionFields
            ? f.options.flatMap((o) => o.fields.map((f) => this.props.fields[f]))
            : [f]
        )
    }
    window.logFieldByName = (name) =>
      Object.values(this.props.fields).filter((field) => field.name === name)
    window.logFieldByFieldId = (fieldId) =>
      Object.values(this.props.fields).filter((field) => field.fieldId === fieldId)
    window.buildFullWizardFieldIdList = () => buildFullWizardFieldIdList()
    window.logWizardPayload = () => this.createPayload()
    window.logFields = () => this.props.fields;
    window.logSigners = () => formatSignaturesForServer(this.props.activeUploadAndSubmitField.value.signers)
    window.stringifySigners = () => {
      console.log(JSON.stringify(formatSignaturesForServer(this.props.activeUploadAndSubmitField.value.signers)))
    }
  }
  componentWillReceiveProps = (nextProps) => {
    if (this.props.activeStep !== nextProps.activeStep) {
      this.setState({ wizardValid: null })
    }
  }
  toggleSubmitModal = () => {
    this.setState({ submitted: !this.state.submitted })
  }
  toggleCheckout = () => {
    this.setState({ checkoutOpen: !this.state.checkoutOpen })
  }
  setActiveStep = (stepIndex) => {
    store.dispatch({
      type: 'SET_ACTIVE_STEP',
      stepIndex,
    })
  }
  nextStep = () => {
    if (this.props.readOnly) {
      this.props.setActiveStep(this.props.activeStep + 1)
    } else {
      this.props.validateAndSetActiveStep(this.props.activeStep + 1)
    }
  }
  prevStep = () => {
    if (this.props.readOnly) {
      this.props.setActiveStep(this.props.activeStep - 1)
    } else {
      this.props.validateAndSetActiveStep(this.props.activeStep - 1)
    }
  }
  getDraftName = () => {
    const field = this.props.fields[this.props.docTitleSrc]
    if (field) {
      switch (field.type) {
        case 'EntityNameSearch':
          return field.value.reservedYN === 'Y' ? field.value.reservedName : field.value.val1
        case 'SearchControl':
          return field.value && field.value.HEADER1
        case 'FullName':
          return field.value.FIRST_NAME + ' ' + field.value.LAST_NAME
        case 'confirmFields':
          return field.value.val1
        default:
          return field.value
      }
    } else {
      return this.props.wizardTitle
    }
  }
  saveDraft = () => {
    this.clearServerError()
    let fieldValues = this.buildFieldJSON()
    const docTitle = this.getDraftName()
    let wizardState = deepCopy(this.props.wizardState)
    delete wizardState.wizard.stepOrder
    delete wizardState.wizard.steps
    delete wizardState.wizard.sections
    delete wizardState.wizard.fields
    let draft = {
      DRAFT_ID: this.props.draftId ? this.props.draftId : 0,
      SOURCE_ID: this.props.sourceId,
      SOURCE_TYPE_ID: 54,
      FORM_DEFINITION_ID: this.props.formDefinitionId,
      ADDITIONAL_INFO_XML: '',
      STATUS: 'Draft',
      WIZARD_JSON: JSON.stringify(fieldValues),
      WIZARD_STATE: JSON.stringify(wizardState),
      DRAFT_NAME: docTitle,
      AMENDMENT_NUM: this.props.amendmentNum,
      CATEGORY: this.props.category,
    }
    //console.log(draft)
    this.props.saveDraft(draft, () => {
      this.props.announce("Your draft has been saved successfully.")
    })
  }
  buildFieldNameMap = (fieldIds) =>
    fieldIds.reduce((obj, fieldId) => {
      const fieldName = this.props.fields[fieldId].name
      obj[fieldName] = (obj[fieldName] || 0) + 1
      return obj
    }, {})
  buildFieldJSON = () => {
    let fieldIds = buildFullWizardFieldIdList()
    let FIELD_VALUES = {}
    let DYNAMIC_DATA = []
    let FIELD_META = {}
    let fieldNameMap = this.buildFieldNameMap(fieldIds)
    fieldIds
    .filter(fieldId => {
      const field = this.props.fields[fieldId];
      const fieldAfterLogicResolution = resolveFieldLogic(field)
      const fieldOnlyHiddenByLogic = field.active && !fieldAfterLogicResolution.active
      if(fieldOnlyHiddenByLogic){
        return false;
      }
      return true;
    })
    .forEach((fieldId) => {
      let field = resolveFieldLogic(this.props.fields[fieldId])
      let kvPairs = new WizardClasses[field.fieldClass]().getKeyValuePairs(field, this.props.fields)
      kvPairs.forEach((pair) => {
        const fieldNameIsNotUnique = fieldNameMap[field.name] > 1
        const shouldUseFieldIdAsFieldName = field.disabled && !field.hideFieldOnForm
        // const metaKey = shouldUseFieldIdAsFieldName ? field.fieldId : field.name
        if (shouldUseFieldIdAsFieldName && fieldNameIsNotUnique) {
          FIELD_VALUES = { ...FIELD_VALUES, [field.fieldId]: [pair.value] }
          FIELD_META = { ...FIELD_META, [field.fieldId]: pair.meta }
        } else {
          if (FIELD_VALUES[pair.name]) {
            FIELD_VALUES = {
              ...FIELD_VALUES,
              [pair.name]: [...FIELD_VALUES[pair.name], pair.value],
            }
          } else {
            FIELD_VALUES = { ...FIELD_VALUES, [pair.name]: [pair.value] }
          }
          FIELD_META = { ...FIELD_META, [pair.name]: pair.meta }
        }
      })
      if (field.dynamic) {
        DYNAMIC_DATA.push(field.name)
      }
    })
    Object.keys(FIELD_VALUES).forEach((key) => {
      if (Array.isArray(FIELD_VALUES[key])) {
        if (FIELD_VALUES[key].length === 1) {
          FIELD_VALUES[key] = FIELD_VALUES[key][0]
        }
      }
    })
    FIELD_META = createMetaCollection(FIELD_META, this.props.wizard, fieldIds)
    const ENCRYPTION = createEncryptionCollection(this.props.wizard)
    const FIELD_OVERRIDES = createFieldOverridesCollection(this.props.wizard)
    const resolvedWizard = this.props.resolveWizardAttributesLogic()
    return {
      FIELD_VALUES,
      DYNAMIC_DATA,
      FIELD_META,
      ENCRYPTION,
      FIELD_OVERRIDES,
      WIZARD_OVERRIDES: this.getWizardOverrides(resolvedWizard),
    }
  }
  getWizardOverrides = wizard => ({
    internalReviewRequired: wizard.internalReviewRequired,
    formTitle: wizard.formTitle,
    feeDescription: wizard.feeDescription
  })
  createPayload = () => {
    const { FIELD_VALUES, DYNAMIC_DATA, FIELD_META, ENCRYPTION, FIELD_OVERRIDES } = this.buildFieldJSON()
    let webUser = JSON.parse(localStorage.getItem('WEB_USER'))
    const resolvedWizard = this.props.resolveWizardAttributesLogic()
    const payload = {
      METADATA: {
        FORM_DEFINITION_ID: this.props.formDefinitionId,
        WEB_USER_ID: webUser ? webUser.WEB_USER_ID : 0,
        SOURCE_ID: this.props.sourceId,
        SOURCE_TYPE_ID: this.props.sourceTypeId,
        AMENDMENT_NUM: this.props.amendmentNum,
        DRAFT_ID: this.props.draftId ? this.props.draftId : 0,
        DYNAMIC_DATA,
        INTERNAL_REVIEW_REQUIRED_YN: resolvedWizard.internalReviewRequired ||  this.props.calculateInternalReview(),
        REDACTION_REQUIRED_YN: this.calculateRedaction(),
        ...this.props.meta,
      },
      FIELD_VALUES,
      FIELD_META,
      ENCRYPTION,
      FIELD_OVERRIDES,
      WIZARD_OVERRIDES: this.getWizardOverrides(resolvedWizard)
    }
    return payload
  }
  calculateRedaction = () => {
    let fields = buildFullWizardFieldIdList().map((fieldId) => this.props.fields[fieldId])
    return fields.reduce((redacted, field) => {
      if (redacted) {
        return true
      } else {
        switch (field.type.toUpperCase()) {
          case 'REPEATER':
            return field.value.length > 0
              ? field.redact
                ? true
                : field.template.some((fid) => this.props.fields[fid].redact)
              : redacted
          default:
            return field.redact
        }
      }
    }, false)
  }
  submit = (saveRoute, extraPayload) => {
    this.props.setWizardSubmitting(true)
    return new Promise((resolve, reject) => {
      validateAllSteps((wizardValid, globalErrorMessages) => {
        this.setState({ wizardValid })
        if (wizardValid) {
          const payload = this.createPayload()
          let mergedPayload = extraPayload ? { ...payload, extraPayload } : payload
          ;(saveRoute || this.props.saveRecord)(
            mergedPayload,
            this.props.category,
            this.props.mode,
            this.props.correctionMode,
            (amendmentNum) => {
              // console.log(amendmentNum)
              this.props.mode === 'correction'
                ? history.push('/receipt')
                : this.setState({ submitted: true })
              this.props.setWizardSubmitted(true)
              this.props.setWizardSubmitting(false)
              resolve(amendmentNum)
            },
            (e) => {
              console.error(e)
              this.props.setWizardSubmitting(false)
              if (
                e.code === 'filing/amendmentSaveFailed' ||
                e.code === 'filing/amendmentImgsNotCreated'
              ) {
                this.setState({
                  serverError: GENERIC_SERVER_ERROR,
                })
              } else if (e.displayInWizard === true) {
                this.setState({
                  serverError: e.message,
                })
              }
            }
          )
        } else {
          this.props.setWizardSubmitting(false)
          this.setState({globalErrorMessage: globalErrorMessages.join('\n')})
          reject(`There are errors in the wizard preventing submission.`)
          const focusable = getFirstFocusableScopedElement('.sidebar', '[aria-invalid="true"]' )
          if(focusable){
            focusable.focus()
          }
        }
      })
    })
  }
  getReceiptItems = (amendmentNum) => {
    return new Promise((resolve, reject) => {
      GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM(
        amendmentNum,
        this.props.category,
        this.props.correctionMode,
        ({
          RECEIPT_ITEM_WEB_LIST,
          RECEIPT_ITEM_CONTAINER_WEB_LIST,
          REF_NUM,
          PAYMENT_METHOD_STATUS_LIST,
        }) => {
          this.setState(
            {
              receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
              receiptItems: RECEIPT_ITEM_WEB_LIST,
              transactionRefNum: REF_NUM,
              availablePaymentMethods: PAYMENT_METHOD_STATUS_LIST,
            },
            () => {
              const total =
                (SHOPPING_CART
                  ? calculateReceiptItemContainersTotal(RECEIPT_ITEM_CONTAINER_WEB_LIST)
                  : calculateReceiptItemsTotal(RECEIPT_ITEM_WEB_LIST)) > 0
              resolve(total)
              if (SHOPPING_CART) {
                this.props.setCartQuantity(
                  RECEIPT_ITEM_CONTAINER_WEB_LIST.filter((x) => !x.IS_FREE).length
                )
              }
            }
          )
        },
        (err) => {
          reject(err)
        }
      )
    })
  }
  testValidate = () => {
    this.clearServerError()
    this.props.setWizardSubmitting(true)
    this.setState({ globalErrorMessage: "" })
    validateAllSteps((wizardValid, globalErrorMessages) => {
      this.setState({ wizardValid })
      if (wizardValid) {
        this.setState({globalErrorMessage: "This wizard is valid, and would be submitted."})
      } else {
        this.props.setWizardSubmitting(false)
        this.setState({globalErrorMessage: globalErrorMessages.join('\n')})
      }
    })
  }
  validateSubmitAndPay = () => {
    this.clearServerError()
    this.submit()
      .then(this.getReceiptItems)
      .then((requiresPayment) => {
        if (requiresPayment) this.toggleCheckout()
        else {
          history.replace(`/receipt?ref=${this.state.transactionRefNum}`)
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }
  validateSubmitAndDownloadPDF = () => {
    this.clearServerError()
    this.submit()
      .then((amendmentNum) => {
        this.getPdfFromJson(null, { amendmentNum }).then(() => {
          window.ALLOW_BYPASS_WIZARD_PROMPT = true
          history.replace(`/queue/${this.props.category}?hid=${amendmentNum}`)
        })
      })
      .catch((e) => {
        console.error(e)
      })
  }
  validateAndSendForSignatures = () => {
    this.clearServerError()
    this.submit(this.props.saveRecordWithSignatures, {
      SIGNERS: formatSignaturesForServer(this.props.activeUploadAndSubmitField.value.signers),
    }).then((groupToken) => {
      window.ALLOW_BYPASS_WIZARD_PROMPT = true;
      history.push(`/signatures/${groupToken}`, { showSuccessMessage: true })
    })
  }
  saveSignature = () => {
    this.clearServerError()
    let errors = {}
    if (!this.props.signatureValues.SIGNATURE)
      errors.SIGNATURE = 'Please sign your name to continue.'

    if (!this.props.signatureValues.SIGNED_DATE) {
      errors.SIGNED_DATE = 'Please provide the date of signing to continue.'
    } else if (differenceInDays(process.env.STATE_TIMEZONE ? new Date(new Date().toLocaleString('en-US', {timeZone: process.env.STATE_TIMEZONE})) : new Date(), new Date(this.props.signatureValues.SIGNED_DATE))) {
      errors.SIGNED_DATE = 'The date signed must be today.'
    }

    this.props.activeUploadAndSubmitField.signerAttestations.forEach((_, i) => {
      if (this.props.signatureValues.attestations[i] !== true) {
        errors.ATTESTATIONS = 'You must attest to all of the above attestations to continue.'
      }
    })

    const isValid = !Object.keys(errors).length
    this.props.setWizardSignatureErrors(errors)
    if (isValid) {
      this.props.setWizardSubmitting(true)
      SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY(
        {
          token: this.props.signature.TOKEN,
          category: this.props.category,
          payload: {
            SIGNED_DATE: this.props.signatureValues.SIGNED_DATE,
            SIGNATURE: this.props.signatureValues.SIGNATURE,
          },
        },
        (successful) => {
          this.props.setWizardSubmitting(false)
          this.props.setWizardSubmitted(true)
          this.props.setGenericSuccess({
            title: 'Successfully submitted',
            message:
              'Your signature was successfully saved. You may now safely close your browser window.',
          })
        },
        (err) => {
          console.error(err)
          this.props.setWizardSubmitting(false)
          this.setState({
            serverError: err.message || GENERIC_SERVER_ERROR,
          })
        }
      )
    } else {
      this.setState({ wizardValid: false })
    }
  }
  startCheckout = () => {
    this.modalRef.current.closeModal(() => {
      this.toggleCheckout()
    })
  }
  cancelCheckout = (callback) => {
    this.slider.closeSlider(() => {
      window.ALLOW_BYPASS_WIZARD_PROMPT = true
      this.toggleCheckout()
      if(!process.env.POST_WIZARD_SUBMIT_REDIRECT_URL){
        if (this.props.category === 'data-request') {
          history.replace(`/data-requests`)
        } else {
          history.replace(`/queue/${this.props.category}`)
        }
      }else{
        history.replace(process.env.POST_WIZARD_SUBMIT_REDIRECT_URL)
      }
      if (typeof callback === 'function') {
        callback()
      }
    })
  }
  redirectToReceipt = (refNum) => {
    this.slider.closeSlider(() => {
      window.ALLOW_BYPASS_WIZARD_PROMPT = true
      history.replace(`/receipt?ref=${refNum || this.state.transactionRefNum}`)
    })
  }
  downloadPrintPdf = () => {
    window.location.assign(
      BASE_URL +
        '/api/Report/FromReactPDF/' +
        this.props.formDefinitionId +
        '/' +
        this.props.amendmentNum
    )
  }
  getReportPreview = () => {
    const {
      title,
      sourceId,
      formDefinitionId,
      category,
      description,
      steps,
      sections,
      fields,
      stepOrder,
    } = this.props.wizard.wizard
    const previewJson = {
      formDefinition: {
        FORM_DEFINITION_ID: formDefinitionId,
        SOURCE_ID: sourceId,
        TITLE: title,
        STEPS_JSON: JSON.stringify({
          stepOrder: stepOrder,
          steps: steps,
          sections: sections,
          fields: fields,
        }),
        CATEGORY: category,
        METADATA: xml2Json.js2xml(this.props.meta),
        DESCR: description,
        ABBREVIATION: '',
        MODE: this.props.mode ? this.props.mode : 'filing',
        DOC_TITLE_SRC: this.props.docTitleSrc,
        DOC_ID: this.props.docId,
        FORM_TITLE: this.props.formTitle,
        INTERNAL_REVIEW_REQUIRED_YN: this.props.internalReviewRequired,
        ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN: this.props.wizard.wizard.onlyRenderChangedFieldsOnForm,
        FEE_DESCR: this.props.feeDescription,
      },
      amendment: JSON.stringify(this.buildFieldJSON()),
    }
    return previewJson
  }
  getPdfFromJson = (_, payload = {}) => {
    return new Promise((resolve, reject) => {
      const previewJson = { ...this.getReportPreview(), ...payload }
      GET_REPORT_BY_JSON(previewJson, (response) => {
        response.blob().then((blob) => {
          const blobObject = window.URL.createObjectURL(blob)
          this.setState({ reportBlob: blobObject, rawBlob: blob }, () => {
            this.downloader.download()
            resolve()
          })
        })
      })
    })
  }
  exportFieldValues = () => {
    const { FIELD_VALUES } = this.buildFieldJSON()
    const dataExport = JSON.stringify({
      ORIGIN_FDID: this.props.formDefinitionId,
      FIELD_VALUES,
    })
    this.setState(
      {
        dataExport,
      },
      () => {
        this.dataDownloader.download()
      }
    )
  }
  refreshCart = () => {
    GET_WEB_USER_ACTIVE_CART(cart => {
      this.setState({
        receiptItemContainers: cart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
        receiptItems: cart.RECEIPT_ITEM_WEB_LIST,
        refNum: this.cart.REF_NUM
      })
    })
  }
  importFieldValues = (e) => {
    readFileAsText(e).then((json) => {
      json = getUniqueJSONvalues(json)
      // console.log(json);
      this.props.reconstructWizardWithValues(json.FIELD_VALUES)
    })
  }
  clearServerError = () => {
    this.setState({ serverError: null, globalErrorMessage: "" })
  }
  getStepsWithErrors = () => (
    this.props.wizard.wizard.stepOrder.map(stepId => this.props.wizard.wizard.steps[stepId])
    .filter(step => !step.isValid)
    .map(step => step.title)
  )
  render() {
    const {
      activeStep,
      stepLength,
      validating,
      savingDraft,
      amendmentNum,
      preview,
      filingMethod,
      lastStep,
      formDefinitionId,
      category,
      correctionMode,
      wizardTitle,
      currentUserGroup,
      readOnly,
      mode,
      uploading,
      entryTypeChanged,
      onlineOverrideLabel,
      printOverrideLabel,
      signerOverrideLabel,
      draftsDisabled,
      isMobile,
    } = this.props
    const unsubmittable = mode === 'unsubmittable'
    const isAdminOrPrviewing =
      preview || currentUserGroup === 'ADMIN' || currentUserGroup === 'ADMIN_WEB'
    const publicImportAllowed = process.env.ALLOW_PUBLIC_JSON_IMPORT && currentUserGroup === 'WEB'

    const wizardInvalidError = (
      <div className={`wizard-toolbar-popover ${isMobile ? 'is-mobile' : ''}`}>
        <button
          onClick={() => {
            this.setState({ wizardValid: null, globalErrorMessage: "" })
          }}
          aria-label="Close Error Message"
        >
          <span className="icon icon-cross" />
        </button>
        <span aria-live="assertive" role="alert">
          It looks like there are some mistakes in the data you've entered. Please review each invalid step
          before continuing.
          {
            this.state.globalErrorMessage ? (
              <React.Fragment>
                <br />
                <br />
                {this.state.globalErrorMessage}
              </React.Fragment>
            ) : null
          }
        </span>
      </div>
    )

    const serverError = (
      <div className={`wizard-toolbar-popover ${isMobile ? 'is-mobile' : ''}`}>
        <button
          onClick={() => {
            this.setState({ serverError: null })
          }}
          aria-label="Close Error Message"
        >
          <span className="icon icon-cross" />
        </button>
        <span aria-live="assertive" role="alert">
          {this.state.serverError}
        </span>
      </div>
    )
    const isInSignatureMode = mode === 'signature'

    return (
      <div className={`toolbar ${isAdminOrPrviewing ? 'admin' : ''}`}>
        {!readOnly && !unsubmittable && category !== 'data-request' && !draftsDisabled && (
          <button type="button" className="btn btn-default save toolbar-button" onClick={this.saveDraft}>
            Save Draft
          </button>
        )}
        {isAdminOrPrviewing && !unsubmittable && (
          <button type="button" className="btn btn-default toolbar-button" onClick={this.getPdfFromJson}>
            Preview Form
          </button>
        )}
        {(isAdminOrPrviewing || publicImportAllowed) && (
          <input
            type="file"
            name="importJson"
            id="importJson"
            accept="application/json"
            className="faux-hide toolbar-button"
            onChange={this.importFieldValues}
          />
        )}
        {(isAdminOrPrviewing || publicImportAllowed) && (
          <label htmlFor="importJson" className="btn btn-default sibling-focus toolbar-button">
            <ImportIcon /> Import
          </label>
        )}
        {(isAdminOrPrviewing || publicImportAllowed) && (
          <button type="button" className="btn btn-default toolbar-button" onClick={this.exportFieldValues}>
            <ExportIcon /> Export
          </button>
        )}
        {savingDraft === false && (
          <div className="save-indicator">
            <span className="icon icon-circle-check animated fadeOut fast-animation pull-left"></span>
            <span className="text animated fadeOut fast-animation pull-left">Saved</span>
          </div>
        )}
        <div className="right-align">
          {/* {
            currentStepIsValid === false && !validating &&
            <span className="loader-text animated fadeIn fast-animation">Review your responses and make corrections to continue</span>
          } */}
          {/* {
            validating &&
            <span className="loader">
              <span className="loader-text animated fadeIn fast-animation">Validating</span>
              <Spinner className="button-loader" size="small" />
            </span>
          } */}
          {activeStep > 0 && !isInSignatureMode && (
            <button type="button" className="btn btn-default prev toolbar-button" onClick={this.prevStep}>
              Previous Step
            </button>
          )}
          {activeStep !== stepLength - 1 && !isInSignatureMode && (
            <button
              type="button"
              className={`btn btn-raised btn-primary next toolbar-button`}
              onClick={this.nextStep}
            >
              Next Step
            </button>
          )}
          {
            preview && lastStep ?
            <button type="button" onClick={this.testValidate} className="btn btn-raised btn-primary next toolbar-button">
              Test Validation
            </button>
            : null
          }
          {filingMethod === 'online' &&
            lastStep &&
            !preview &&
            (!readOnly || entryTypeChanged) &&
            (!unsubmittable || entryTypeChanged) &&
            mode !== 'signature' && (
              <button
                type="button"
                disabled={uploading}
                className="btn btn-raised btn-primary next toolbar-button"
                onClick={this.validateSubmitAndPay}
                aria-busy={this.state.submitted || this.props.submitting || validating}
                aria-live="polite"
              >
                {validating || this.state.submitted ? (
                  <div className="center">
                    <Spinner className="validation-loader" size="small" color="currentcolor" />
                    <span>{this.state.submitted ? 'Submitting' : 'Validating'}</span>
                  </div>
                ) : (
                  onlineOverrideLabel || 'File Online'
                )}
              </button>
            )}
          {filingMethod === 'mail' &&
            lastStep &&
            !isInSignatureMode &&
            !preview &&
            (!readOnly || entryTypeChanged) &&
            (!unsubmittable || entryTypeChanged) && (
              <button
                type="button"
                disabled={uploading}
                className="btn btn-raised btn-primary next toolbar-button"
                onClick={this.validateSubmitAndDownloadPDF}
                aria-busy={this.state.submitted || this.props.submitting || validating}
                aria-live="polite"
              >
                {
                  validating || this.state.submitted ? (
                    <div className="center">
                      <Spinner className="validation-loader" size="small" color="currentcolor" />
                      <span>{this.state.submitted ? 'Submitting' : 'Validating'}</span>
                    </div>
                  )
                  : (printOverrideLabel || 'Print and Mail')
                }
              </button>
            )}
          {filingMethod === 'signer' &&
            lastStep &&
            !preview &&
            !isInSignatureMode &&
            (!readOnly || entryTypeChanged) &&
            (!unsubmittable || entryTypeChanged) && (
              <button
                type="button"
                disabled={uploading}
                className="btn btn-raised btn-primary next toolbar-button"
                onClick={this.validateAndSendForSignatures}
                aria-busy={this.state.submitted || this.props.submitting || validating}
                aria-live="polite"
              >
                {validating || this.state.submitted ? (
                  <div className="center">
                    <Spinner className="validation-loader" size="small" color="currentcolor" />
                    <span>
                      {this.state.submitted
                        ? signerOverrideLabel || 'Send for Signatures'
                        : 'Validating'}
                    </span>
                  </div>
                ) : (
                  signerOverrideLabel || 'Send for Signatures'
                )}
              </button>
            )}
          {isInSignatureMode && (
            <button
              type="button"
              disabled={uploading}
              className="btn btn-raised btn-primary next toolbar-button"
              onClick={this.saveSignature}
              aria-busy={this.state.submitted || this.props.submitting || validating}
              aria-live="polite"
            >
              {validating || this.props.submitting || this.state.submitted ? (
                <div className="center">
                  <Spinner className="validation-loader" size="small" color="currentcolor" />
                  <span>Submitting</span>
                </div>
              ) : (
                signerOverrideLabel || 'Submit Signature'
              )}
            </button>
          )}
          {lastStep &&
            filingMethod === null &&
            (!readOnly || entryTypeChanged) &&
            (!unsubmittable || entryTypeChanged) && (
              <button
                type="button"
                className="btn btn-raised btn-primary next toolbar-button"
                onClick={this.getPdfFromJson}
              >
                Download PDF
              </button>
            )}
        </div>
        {this.state.wizardValid === false &&
          (isMobile ? <Portal isOpened>{wizardInvalidError}</Portal> : wizardInvalidError)}
        {this.state.serverError &&
          (isMobile ? <Portal isOpened>{serverError}</Portal> : serverError)}

        <FileDownloader
          ref={(downloader) => {
            this.downloader = downloader
          }}
          href={this.state.reportBlob}
          blob={this.state.rawBlob}
          fileName={wizardTitle + '.pdf'}
        />
        <FileDownloader
          ref={(downloader) => {
            this.dataDownloader = downloader
          }}
          fileString={this.state.dataExport}
          fileName={'DATA_' + wizardTitle + '.json'}
        />
        <Portal isOpened={this.state.checkoutOpen}>
          <SlidingPanel
            closeOnShadeClick={false}
            closeSlider={this.toggleCheckout}
            ref={(r) => {
              this.slider = r
            }}
          >
            <Checkout
              cancelCheckout={this.cancelCheckout}
              closeModal={this.toggleCheckout}
              redirectToReceipt={this.redirectToReceipt}
              amendmentNum={amendmentNum}
              formDefinitionId={formDefinitionId}
              category={category}
              correctionMode={correctionMode}
              receiptItems={this.state.receiptItems}
              receiptItemContainers={this.state.receiptItemContainers}
              refNum={this.state.transactionRefNum}
              availableMethods={this.state.availablePaymentMethods}
              onCartRefresh={this.refreshCart}
            />
          </SlidingPanel>
        </Portal>
      </div>
    )
  }
}
Toolbar = connect(
  (state) => {
    const filingMethod =
      state.wizard.requirePrintMailMethod.size > 0
        ? [{ value: { method: 'mail' } }]
        : getFieldsByType('UploadAndSubmit', state.wizard.wizard.fields)
    const activeFilingMethods =
      filingMethod &&
      filingMethod.filter((field) =>
        resolveFieldConditions(
          field.conditions,
          state.wizard.wizard.fields,
          field.conditionsOperator
        ) &&
        (field.logicNodes ? resolveFieldLogic(field).active : true)
      )
    const method = activeFilingMethods
      ? activeFilingMethods[0] && activeFilingMethods[0].value.method
      : null
    const stepLength = Object.keys(state.wizard.wizard.steps).length
    return {
      activeStep: state.wizard.activeStep,
      stepLength,
      lastStep: stepLength - 1 === state.wizard.activeStep,
      fields: state.wizard.wizard.fields,
      sourceId: state.wizard.wizard.sourceId,
      formDefinitionId: state.wizard.wizard.formDefinitionId,
      meta: state.wizard.wizard.meta,
      wizardTitle: state.wizard.wizard.title,
      onlineOverrideLabel: activeFilingMethods
        ? activeFilingMethods[0] && activeFilingMethods[0].onlineButtonLabel
        : '',
      printOverrideLabel: activeFilingMethods
        ? activeFilingMethods[0] && activeFilingMethods[0].printButtonLabel
        : '',
      signerOverrideLabel: activeFilingMethods
        ? activeFilingMethods[0] && activeFilingMethods[0].signerButtonLabel
        : '',
      activeUploadAndSubmitField: activeFilingMethods ? activeFilingMethods[0] || {} : {},
      validating: state.wizard.validating,
      draftId: state.wizard.draftId,
      savingDraft: state.wizard.savingDraft,
      readOnly: state.wizard.readOnly,
      currentStepIsValid:
        state.wizard.wizard.steps[state.wizard.wizard.stepOrder[state.wizard.activeStep]].isValid,
      mode: state.wizard.mode,
      amendmentNum: state.wizard.wizard.amendmentNum,
      preview: state.wizard.preview,
      docTitleSrc: state.wizard.wizard.docTitleSrc,
      docId: state.wizard.wizard.docId,
      formTitle: state.wizard.wizard.formTitle,
      filingMethod: method,
      category: state.wizard.wizard.category,
      correctionMode: state.wizard.correctionMode,
      wizardState: state.wizard,
      internalReviewRequired: state.wizard.wizard.internalReviewRequired,
      wizard: state.wizard,
      currentUserGroup: state.auth.USER_GROUP,
      feeDescription: state.wizard.wizard.feeDescription,
      uploading: state.wizard.uploading,
      entryTypeChanged: state.wizard.readOnly
        ? !deepEqual(state.wizard.diff.original.UPLOADS.method, method)
        : false,
      draftsDisabled: state.wizard.wizard.draftsDisabled,
      isMobile: state.app.isMobile,
      signatureValues: state.wizard.signatureValues,
      signature: state.wizard.signature,
      submitting: state.wizard.submitting,
    }
  },
  {
    validateAndSetActiveStep,
    resolveWizardAttributesLogic,
    saveRecord,
    saveDraft,
    saveRecordWithSignatures,
    calculateInternalReview,
    setActiveStep,
    reconstructWizardWithValues,
    setErrorToast,
    setWizardSubmitted,
    setWizardSubmitting,
    setWizardSignatureErrors,
    setGenericSuccess,
    setCartQuantity,
    announce,
  }
)(Toolbar)



// WEBPACK FOOTER //
// ./src/components/Wizard2/Wizard.js